import { FC, useMemo } from "react";

import { unique } from "@ryde/shared";

import { MessagesDisplayItem } from "./messages-display.item";
import { IMessagesType } from "./messages-display.models";

interface IMessagesDisplayServerContainer {
  serverMessages: string[] | undefined;
  type: IMessagesType;
}

export const MessagesDisplayServerContainer: FC<
  IMessagesDisplayServerContainer
> = ({ serverMessages, type }) => {
  const serverMessagesNormalized = useMemo(() => {
    return serverMessages?.length ? unique(serverMessages) : [];
  }, [serverMessages]);

  return serverMessagesNormalized?.map((message, i) => (
    <MessagesDisplayItem
      key={`${message}_${i}`}
      messageDescription={message}
      type={type}
    />
  ));
};
